/**
 * Created by anatoly on 27.02.2025
 */

const GeneratorHintLogics = {
    type: "generate",
    priority: 0,

    chooseConfig: function () {
        const location = cleverapps.meta.getSelectedLocation();
        const fix = location.getContinuousStage();

        if (fix >= 9) {
            return { delay: 3000, interval: 7000 };
        }

        if (fix >= 3) {
            return { delay: 3000, interval: 3000 };
        }

        return { delay: 3000, interval: 1000 };
    },

    findMove: function () {
        const config = this.chooseConfig();
        if (!config) {
            return;
        }

        if (!GeneratorHintLogics.canFindMove()) {
            return;
        }

        const generators = Merge2.current.field.listAvailableUnits().map((unit) => unit.findComponent(Merge2Generator)).filter((generator) => generator && generator.canStartMine());
        const generator = PseudoRandom.GET().choose(generators);

        if (generator) {
            return {
                type: GeneratorHintLogics.type,
                delay: config.delay,
                interval: config.interval,
                cell: cc.p(generator.unit.x, generator.unit.y)
            };
        }
    },

    canFindMove: function () {
        return Merge2.current && Merge2.current.isGameMode();
    }
};

AvailableMove.REGISTERED_ALGORITHMS.push(GeneratorHintLogics);